(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.submission.name)
    .factory('submissionLogsSvc', ['$http', '$q', function ($http, $q) {

           	var getAllSubmissionLogs = function (keycode, type) {
                console.info('In getAllSubmissionLogs service');
                console.info('Making a call to service');
                var allSubmissionLogs = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.submission.endpoints.getSubmissionsLogsEndpoint + type,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    allSubmissionLogs = response.data;
                    deferred.resolve(allSubmissionLogs);
                    console.info('Got the submission logs');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
            
            return {
                getAllSubmissionLogs: getAllSubmissionLogs
            };
        }

    ]);
}(angular, schoolwork12));